module.exports = __webpack_public_path__ + "static/img/bg_1png.859edd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_1png.png
// module id = UcLx
// module chunks = 1